
/**
 *	globals:
 *
 *	Allgemeine states, die von verschiedenen components / views
 *	benötigt werden.
 *
 * 	Beispiel zum Ändern eines globalen Wertes von einer Komponente aus:
 * 	this.$store.commit('globals/SET_APP_ATTRIBUTES', obj);
 * 
 * 	Zugriff auf Wert aus Komponente:
 * 	this.$store.state.globals
 * 
 * 	Alternativ mapState() verwenden:
 * 	import { mapState } from 'vuex';
 * 	computed: {
 * 		...mapState('globals', ['app']),
 * 	}
 * 	Zugriff: this.app.width
 * 	
 */

export const state = {
	tabbar: false,
	history: [],
	current: false,
	app: {
		windowHeight: 0,
		width: 0,
		height: 0,
		tabbarHeight: 0,
	}
}

export const mutations = {

	/**
	 * 	Tabbar zeigen / verstecken.
	 * 	Wird von Tabbar.vue nach Navigation über den Router übernommen.
	 */
	TOGGLE_TABBAR (state, showFlag ) {
		state.tabbar = showFlag;
	},

	/**
	 * 	Einen Schritt in History aufzeichnen.
	 */
	PUSH_HISTORY (state, pageOrStackRef ) {
		state.history.push( pageOrStackRef );
		state.current = pageOrStackRef;
	},
	
	/**
	 * 	Einen Schritt zurück in der History gehen.
	 */
	POP_HISTORY (state) {
		if (state.history.length > 1) {
			state.history.pop();
		}
		state.current = state.history.slice(-1)[0];
		return state.current;
	},

	SET_CURRENT (state, pageOrStackRef ) {
		state.current = pageOrStackRef;
	},

	SET_APP_ATTRIBUTES(state, attributes) {
		state.app = Object.assign( state.app, attributes );
	}
}

export const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
